import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Dto } from '@models/dto.model';
import { UserInfo } from '@models/userInfo.dto';
import { environment } from '@env';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(protected _http: HttpClient)
  { }

  getPartnerUserInfo(): Observable<Dto<UserInfo>> {
    return this._http.get<Dto<UserInfo>>(
      `${environment.apiTMPartner}/PartnerClient/PartnerUserInfo`);
  }
}
